import React from "react";
import { useTranslation } from "react-i18next";

import { ToggleArrow } from "./toggleArrow";
import { Props } from "./types";
import styles from "./styles.scss";

function TreeControls(props: Props) {
  const { t } = useTranslation();

  return (
    <div className={styles.treeControls}>
      <div
        className={styles.openAll}
        title={t(props.expandAllKey)}
        onClick={props.expandAll}
      >
        <ToggleArrow className={styles.toggleArrow} />
      </div>
      <div
        className={styles.closeAll}
        title={t(props.collapseAllKey)}
        onClick={props.collapseAll}
      >
        <ToggleArrow className={styles.toggleArrow} />
      </div>
    </div>
  );
}

export { TreeControls };
